import groq from 'groq'
import { MediaObjectQuery } from '~/app/queries/molecules/MediaObjectQuery'
import { ButtonQuery } from '../atoms/ButtonQuery'

export const textWithIllustrationQuery = groq`
  _type == 'textWithIllustration' => {
    _type,
    _key,
    flip,
    disableCrop,
    ${MediaObjectQuery},
    design{...,},
    innerBlocks[]{
        ...,
        _type == "button" => {
          ${ButtonQuery}
        },
      }

  }
`
